import React from 'react';
import { Link } from 'react-router-dom';
import { UserCircle, ShieldCheck, Award } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Вкладки профиля: «Профиль» (кто я, уведомления, комиссии), «Безопасность»
 * (вход, устройства, сессии) и «Достижения» (грамоты). Это отдельные страницы —
 * /profile, /security и /achievements, а не
 * состояние одной: на вкладку можно дать ссылку, и «назад» работает как ждёшь.
 */
export const ProfileTabs: React.FC<{ active: 'profile' | 'security' | 'achievements' }> = ({ active }) => {
  const { t } = useTranslation('security');
  const tabs = [
    { id: 'profile' as const, to: '/profile', label: t('tabs.profile'), icon: <UserCircle size={15}/> },
    { id: 'security' as const, to: '/security', label: t('tabs.security'), icon: <ShieldCheck size={15}/> },
    { id: 'achievements' as const, to: '/achievements', label: t('tabs.achievements'), icon: <Award size={15}/> },
  ];
  return (
    // Таблетки в стиле терминала (15.10). На 390 px три вкладки едва
    // помещаются — ряд прокручивается сам, если язык длиннее.
    <nav className="max-w-full overflow-x-auto [scrollbar-width:none]">
      <div className="sb-seg !flex w-max min-w-full sm:min-w-0">
        {tabs.map(tab => {
          const on = tab.id === active;
          return (
            <Link key={tab.id} to={tab.to} aria-current={on ? 'page' : undefined} data-on={on}
              className={'sb-seg-btn !h-9 flex-1 justify-center !px-3 !text-[13px] sm:flex-none '
                + (on ? 'bg-secondary shadow-[0_1px_0_hsl(var(--foreground)/0.06)_inset,0_2px_8px_-2px_rgb(0_0_0/0.35)] [&>svg]:text-primary' : '')}>
              {tab.icon} {tab.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default ProfileTabs;
